export const menuData = [
  { title: "Courses", icon: "/images/icons/courses.svg", link: "/courses" },
  {
    title: "Quizzes",
    icon: "/images/icons/tutorials.svg",
    link: "/quizzes",
  },
  { title: "Pricing", icon: "/images/icons/pricing.svg", link: "/pricing" },
  { title: "Account", icon: "/images/icons/account.svg", link: "/Account" },
  { title: "Search", icon: "/images/icons/search.svg", link: "/Welcome" },
]

export const tooltipData = [
  { title: "Profile", icon: "/images/icons/profile.svg", link: "/profile" },
  { title: "Settings", icon: "/images/icons/settings.svg", link: "/settings" },
  { title: "Sign out", icon: "/images/icons/signout.svg", link: "/logout" },
]
